import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "fontpicker-container float-start" };
const _hoisted_2 = ["onClick"];
import WebFontLoader from 'webfontloader';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FontPicker',
    props: {
        defaultFont: null
    },
    emits: ["fontChanged"],
    setup(__props, { emit }) {
        const props = __props;
        const googleFontFamilies = ['Allura', 'Caveat Brush', 'Dynalight', 'Kanit', 'Nanum Brush Script', 'Nerko One', 'Nunito', 'Poor Story', 'Rock Salt', 'Rubik Bubbles'];
        const customFontFamilies = ['Brusher', 'Carnation'];
        const fontFamilies = googleFontFamilies.concat(customFontFamilies);
        const dropdownVisible = ref(false);
        const selectedFont = ref(props.defaultFont);
        function setFont(fontName) {
            selectedFont.value = fontName;
            dropdownVisible.value = !dropdownVisible;
            emit('fontChanged', {
                fontName: fontName,
                cssClass: className(selectedFont.value),
            });
        }
        function className(fontName) {
            return fontName.split(" ").join("-").toLowerCase();
        }
        WebFontLoader.load({
            google: { families: googleFontFamilies },
            custom: {
                families: customFontFamilies,
                urls: ['/css/ccmfonts.css']
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    class: "btn btn-secondary btn-md dropdown-toggle",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event) => (dropdownVisible.value = !dropdownVisible.value))
                }, _toDisplayString(selectedFont.value), 1),
                _createElementVNode("ul", {
                    id: "fontpicker-dropdown",
                    class: _normalizeClass({ dnone: (!dropdownVisible.value) })
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fontFamilies), (font) => {
                        return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(className(font)),
                            onClick: ($event) => (setFont(font))
                        }, _toDisplayString(font), 11, _hoisted_2));
                    }), 256))
                ], 2)
            ]));
        };
    }
});
